<script setup lang="ts">
import VFormFilterButton from '@modules/form-widgets/components/VFormFilterButton/VFormFilterButton.vue';
import VFormErrorTag from '@modules/forms/components/VFormErrorTag/VFormErrorTag.vue';

import type { VFormButtonsGroupWidgetEmits, VFormButtonsGroupWidgetProps } from './types';

const props = withDefaults(defineProps<VFormButtonsGroupWidgetProps>(), {
  addType: 'transparent',
});
const emit = defineEmits<VFormButtonsGroupWidgetEmits>();

function onRemove(index: number): void {
  if (!props.readonly) {
    emit('remove', index);
  }
}
</script>

<template>
  <div v-data-qa-auto-id="'VFormButtonsGroupWidget'"
    class="flex flex-wrap items-center"
    :class="{ 'gap-2': !noGap, 'flex-col': flexDirectionColumn }"
  >
    <div
      v-if="label"
      class="mr-4 pl-3 text-sm text-muted-color"
    >
      {{ label }}
    </div>

    <VFormFilterButton
      v-for="({ allowRemove, ...button }, index) in buttons"
      :key="index"
      v-bind="button"
      :allow-remove="allowRemove && !readonly"
      class="py-1"
      @click="emit('select-item', index)"
      @click-remove="onRemove(index)"
      @click-expand="emit('expand-toggle', index)"
    />

    <VFormFilterButton
      v-if="addLabel && !readonly"
      :label="addLabel"
      is-add
      is-clickable
      :type="addType"
      :no-pointer-events="addNoPointerEvents"
      :add-icon="addIcon"
      @click="emit('add')"
    />

    <VFormErrorTag
      class="min-w-[140px]"
      :errors="errors"
    />
  </div>
</template>
